import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function PrivateRoute() {
  const { ready, authed } = useAuth();
  if (!ready) return null; // 로딩중
  return authed ? <Outlet /> : <Navigate to="/login" replace />;
}
